<template>
<b-modal
  id="modal-error-connect"
  size="lg"
  hide-footer
  title="Detalle error del archivo"
  :ok-variant="'primary'"
  :cancel-variant="'secondary'"
  :no-close-on-backdrop="true"
  :no-close-on-esc="true">
  <div class="px-2">
    <p class="text-primary font-weight-bold pt-2">Listado de errores en el documento</p>
    <div class="error-table-container-disable">
      <table-render :key="keyTableRender" :rows="rows" :schema="schema"/>
    </div>
  </div>
</b-modal>
</template>

<script>
export default {
  name: 'modal-error-connect',
  props: {
    errorsList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      keyTableRender: 0,
      schema: [
        {label: 'Error', key: 'title_error'},
        {label: 'Detalle', key: 'detail', useDangerHTML: true}
      ],
      rows: []
    }
  },
  watch: {
    errorsList: {
      immediate: true,
      handler(newVal) {
        this.rows = newVal?.map((error, index) => ({
          id: index,
          title_error: error.title || 'Error en la validación',
          detail: error.detail
        })) || []
      }
    }
  }
}
</script>